import { Component, Input } from '@angular/core';
import { DEFAULT_STYLE_OPTIONS } from '../../../constants/default-style-options';

@Component({
    selector: 'aumico-annualReport-complementary-report-german-display-component',
    templateUrl: 'complementary-report-german-display.component.html',
    styleUrls: ['complementary-report-german-display.component.scss'],
})
export class ComplementaryReportGermanDisplayComponent {
    @Input() complementaryReportContent: string;
    @Input() backgroundColor: string = DEFAULT_STYLE_OPTIONS.backgroundColor;
    @Input() textColor = DEFAULT_STYLE_OPTIONS.textColor;

}
